import { getTranslationWithParams } from "common";
import { useTranslations } from "hooks";
import { useCallback } from "react";

/**
 * Chiavi **di layout** della superficie Statistiche SLA (schede KPI, grafico del
 * trend, tabella per periodo, tabella di dettaglio). Non sono nel catalogo P1:
 * vivono qui, separate da `SLA_STATISTICS_TEXT_KEYS` (che e' il manifest P1 e
 * deve combaciare con `e2e/tests/sla/helpers/slaContract.ts`). Il testo viene
 * solo dal catalogo.
 */
export const SLA_STATISTICS_UI_TEXT_KEYS = {
  /** "{met} di {total} in tempo" sotto la percentuale di una base. */
  metOf: "sla.statistics.kpi.met_of",
  /** Descrizione accessibile del grafico del trend. */
  trendAria: "sla.statistics.trend.aria",
  /** Colonne della tabella per periodo. */
  tableCompleted: "sla.statistics.table.completed",
  tableOnTime: "sla.statistics.table.on_time",
  tableBreached: "sla.statistics.table.breached",
  tableHint: "sla.statistics.table.hint",
  /** Riga unica degli esiti fuori dal calcolo. */
  excludedTitle: "sla.statistics.excluded.title",
  /** Colonne della tabella di dettaglio (drill-down). */
  drilldownInstance: "sla.statistics.drilldown.instance",
  drilldownElement: "sla.statistics.drilldown.element",
  drilldownClosedAt: "sla.statistics.drilldown.closed_at",
  drilldownWorkingTime: "sla.statistics.drilldown.working_time",
  close: "sla.statistics.drilldown.close",
  /** Tabella "Per processo" (ripartizione per modello, `/breakdown/model`). */
  byModelTitle: "sla.statistics.by_model.title",
  byModelProcess: "sla.statistics.by_model.process",
  byModelEffective: "sla.statistics.by_model.effective_rate",
  byModelOriginal: "sla.statistics.by_model.original_rate",
  byModelAverage: "sla.statistics.by_model.average_time",
  byModelUnknown: "sla.statistics.by_model.unknown",
  byModelHint: "sla.statistics.by_model.hint",
  /** Aiuto (icona info) accanto alle etichette delle schede KPI. */
  helpEffective: "sla.statistics.help.effective",
  helpOriginal: "sla.statistics.help.original",
  helpSampleSize: "sla.statistics.help.sample_size",
} as const;

/**
 * Testo della superficie Statistiche dal catalogo (stesso schema di
 * `useSlaEditorText`): i segnaposto `{param}` vengono interpolati da
 * `getTranslationWithParams`; senza traduzione resta la chiave.
 */
const useSlaStatisticsText = () => {
  const translations = useTranslations();

  return useCallback(
    (key: string, params: Record<string, string | number> = {}): string =>
      getTranslationWithParams(translations, key, params),
    [translations],
  );
};

export default useSlaStatisticsText;
